/**
 * The platform's official social profiles — ONE source of truth.
 *
 * Two consumers, for two different purposes:
 *  1. components/Footer.tsx renders them as visible links (for people).
 *  2. index.html's Organization JSON-LD lists them under `sameAs` (for search
 *     engines). `sameAs` is an ownership claim — "these accounts ARE this
 *     organisation" — which a plain footer link does not assert, since linking
 *     to an account is equally what our gym pages do for gyms we don't own.
 *
 * index.html is a static shell and cannot import this module, so its sameAs
 * array repeats these URLs literally. lib/socialLinks.test.ts asserts the two
 * lists match exactly, so the copy cannot silently drift.
 */
export const SOCIAL_PROFILE_URLS: readonly string[] = [
    'https://www.facebook.com/profile.php?id=61576414850962',
    'https://www.instagram.com/martialartsnetwork_au/',
    'https://www.threads.com/@martialartsnetwork_au',
    'https://www.youtube.com/@martialartsnetwork_au',
];
